import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {Link, useLocation} from 'react-router-dom';
import {NewTabLink, PageTitle} from 'fn-common-ui';
import 'bootstrap/dist/js/bootstrap.bundle'; // bootstrap is required for modals

import Accordion from '../components/accordion/accordion';
import Alert from '../components/alert/alert';
import AdminSubHeader from '../components/header/admin-subheader';
import {utilsService} from '../core/services/utils.service';
import { SearchForm } from '../components/search/search-form';

@inject('store')
@observer
class TrainingPortalPage extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    showAdminSubHeader: PropTypes.bool,
    location: PropTypes.object
  }

  static defaultProps = {
    showAdminSubHeader: false
  }

  componentDidMount() {
    const locationState = this.props.location && this.props.location.state;
    if (locationState && locationState.alertText) {
      this.props.store.newMasterStore.alert.showAlert({
        type: locationState.alertType,
        text: locationState.alertText
      });
    }
  }

  renderEditButton(section, id) {
    if (this.props.store.newMasterStore.isInEditMode) {
      return (
        <div className="floating-action-wrapper">
          <Link className="floating-action btn" to={`/content/edit/${section}/${id}`}>
            <i className="icon icon-pencil"/>
            Edit
          </Link>
        </div>
      )
    }
  }

  renderTopHero() {
    const model = this.props.store.newMasterStore.ContentItems.top;
    if(!model) return null;
    return (
      <div className="hero-banner intro">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12">
              {/* {this.renderEditButton('top', model.id)} */}
            </div>
            <div className="hero-text-top col-12 col-lg-12">
              {/* <h1 style={{textTransform:'none'}}>How-to guides & training materials</h1> */}
              {/* <h2>{model.title}</h2> */}
              <p style={{marginBottom:'0px'}}>Get help with all things FirstNet. Browse videos, user guides, and FAQs, or register for instructor-led training. </p>
              {/* <p>
                <NewTabLink
                  role="button"
                  id={model.fileName}
                  to={fileSrc}
                  className="fn-primary click-tracked"
                  hideIcon={true}>
                  View Presentation
                </NewTabLink>
              </p> */}
              

            </div>
            <div className="search-container walkthrough-search-and-filter col-12" style={{ overflowX: 'clip'}}>
            <div className="search-form-wrapper">
            <div className="row">
              <div className="col-12 col-sm-4">
                <SearchForm store={this.props.store}/>
              </div>
              
            </div>
          </div>
            </div>
            
          </div>
        </div>
      </div>
    )
  }
  
  renderBottomHero() {
    const model = this.props.store.newMasterStore.ContentItems.bottom;
    if(!model) return null;
    const fileSrc = model.fileName
      ? utilsService.getFilePath(model.fileName)
      : '';

    return (
      <section className="hero-banner customer-service">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12">
              {this.renderEditButton('bottom', model.id)}
            </div>
            <div className="hero-text col-12 col-md-6">
              <h2 className="title">{model.title}</h2>
              <p>{model.description}</p>
              <p className="button-container">
                <NewTabLink
                  role="button"
                  id={model.fileName}
                  to={fileSrc}
                  className="fn-inverse view-guide-button click-tracked"
                  hideIcon={true}>
                  View Guide
                </NewTabLink>
              </p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  renderLoadingAnimation = () => {
    return (
      <div
        className="fn-loading"
        role="status"
        aria-busy={true}
        aria-labelledby="vid-loading-title" style={{paddingTop:'25px'}}>
        <h1 id="vid-loading-title" className="fn-loading-text" style={{color: 'black'}}>Loading...</h1>
        <div className="fn-loading-circle" aria-hidden={true}>
          {[...Array(12)].map((x, i) => <div key={i} className={`s${i + 1} s`}></div>)}
        </div>
      </div>
    )
  }

  render() {
    const alert = this.props.store.newMasterStore.alert;
    return (
      <main id="main-content">
      {this.props.showAdminSubHeader && <AdminSubHeader />}
        <section id="training-portal">
          <PageTitle className="sr-only">Quick help & tutorials</PageTitle>
          <div className="container">
            <Alert {...alert} onHide={alert.hideAlert} />
          </div>
          {this.renderTopHero()}
          {
            this.props.store.isSearching && this.renderLoadingAnimation()
          }
          <Accordion />
          {this.renderBottomHero()}
        </section>
      </main>
    )
  }
}

export default function TrainingPortalPageWrapper(props) {
  const location = useLocation();
  return <TrainingPortalPage {...props} location={location} />;
}
